import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
import { NgForm } from '@angular/forms';
import { NgModule } from '@angular/core';

@Component({
    selector: 'step-3',
    providers: [],
    styles: [],
    template: require('./step-3.html')
})
export class VmStorageList {
    @Input() datastores = [];
    @Output() onDestinationDatastoreSelection = new EventEmitter();

    private selectedDatastore;

    constructor(private translate:TranslateService,) {
        translate.use(GlobalVariables.LOCALE);
    }

    // Life Cycle Hooks
    ngOnInit() {
    }

    ngOnChanges(changes) {
        this.selectedDatastore = ( this.datastores && this.datastores.length > 0 ) ? this.datastores[0] : '';
        this.onDatastoreSelection(this.selectedDatastore);
    }

    onDatastoreSelection(datastore) {
        if ( datastore && datastore !== '' ) {
            this.onDestinationDatastoreSelection.emit(datastore);
        } else {
            this.onDestinationDatastoreSelection.emit();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/step-3/step-3.component.ts